import React, { useContext } from 'react';
import './retail.scss';
import AppContext from 'containers/App/Store/AppContext';
import { useMediaQuery } from '@material-ui/core';
import theme from '@ifca-root/react-component/src/assets/theme';

interface RetailPOSSubheaderProps {
	title?: any;
	infoLine?: any;
}

export const RetailPOSSubheader: React.FC<RetailPOSSubheaderProps> = ({
	title,
	infoLine,
}) => {
	const { globalState }: any = useContext(AppContext as any);

	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});

	return (
		<div
			className="retail-pos-subheader"
			style={{
				width:
					isDesktop && globalState.drawerOpen
						? 'calc((100% - 288px) * 5 / 12)'
						: 'calc((100% - 48px) * 5 / 12)',
			}}
		>
			{title && <div className="retail-pos-subheader-title">{title}</div>}
			{infoLine && <div className="retail-pos-subheader-info">{infoLine}</div>}
		</div>
	);
};

export default RetailPOSSubheader;
